// We don't need everything.
// This saves about 300 kb minified
var core = require('mathjs/core');
var math = module.exports = core.create();
//math.import(require('mathjs/lib'));
math.import(require('mathjs/lib/type/fraction'));
math.import(require('mathjs/lib/type/complex'));
math.import(require('mathjs/lib/function/arithmetic'));
math.import(require('mathjs/lib/function/relational'));
math.import(require('mathjs/lib/function/string/format'));
math.import(require('mathjs/lib/expression/function/eval'));
math.import(require('mathjs/lib/constants'));
